import React, { useEffect, useRef } from 'react';

import { useLocation } from 'react-router-dom';

import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Constants from '../utils/constants';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import HttpService from '../services/HttpService';
import CircleIcon from '@mui/icons-material/Circle';
import { useStore } from '../utils/store';
import { Box } from '@mui/material';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import { setStoredMenuItems } from '../utils/storageUtil';
const SideBar: React.FC = () => {
  const isInitialLoad = useRef(true);
  const {
    getAdmin,
    setLoumacMenuItems,
    getMenuItems,
    loumacMenuItems,
    setIsLoginUsername,
    isLoginUsername,
  } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path: string) =>
    location.pathname.split('/').includes(getActiveItemModule(path));
  const [open, setOpen] = React.useState<boolean>(false);
  const [currentMenu, setCurrentMenu] = React.useState<any>('');

  const [loumacMenus, setLoumacMenus] = React.useState<any[]>([]);
  const getLink = (parentItem: any, keyword: string) => {
    return (
      '/' + getActiveItemModule(parentItem) + '/' + getActiveItemModule(keyword)
    );
  };
  const getActiveMenu = (parentItem: any, keyword: string) => {
    const pathArr: any = location.pathname.split('/');
    let currentPath: any = location.pathname;
    if (pathArr.length === 4) {
      currentPath = currentPath.replace('/' + pathArr[3], '');
    }
    return (
      currentPath ===
      '/' + getActiveItemModule(parentItem) + '/' + getActiveItemModule(keyword)
    );
  };
  const getActiveItemModule = (keyword: string) => {
    return keyword.toLowerCase().replaceAll('_', '-');
  };
  const handleClick = (openType: string) => {
    const pathKeyword = getActiveItemModule(openType);
    if (!open) {
      setOpen(true);
    } else if (open && pathKeyword === currentMenu) {
      setOpen(false);
    }

    setCurrentMenu(pathKeyword);
  };
  useEffect(() => {
    if (isInitialLoad.current) {
      if (loumacMenus.length === 0 && getMenuItems().length === 0) {
        fetchBundleData();
        isInitialLoad.current = false;
      } else {
        if (getMenuItems().length > 0) setLoumacMenus(getMenuItems());
        else fetchBundleData();
      }
      if (!isLoginUsername)
        setIsLoginUsername(localStorage.getItem('username') || 'User');
    } else {
      console.log('getMenuItems()');
      console.log(getMenuItems());
      console.log('getMenuItems()');
      if (getMenuItems().length > 0) setLoumacMenus(getMenuItems());
      else fetchBundleData();
    }
    const currentModule = location.pathname.split('/');
    setCurrentMenu(currentModule[1]);
    setOpen((prevOpen) => !prevOpen);
  }, []);
  useEffect(() => {
    console.log(loumacMenuItems, 'loumacMenuItems');
    if (loumacMenuItems) {
      if (loumacMenuItems.length > 0) {
        setLoumacMenus(loumacMenuItems);
      }
    }
  }, [loumacMenuItems]);
  // Fetch single term record
  const fetchBundleData = async () => {
    try {
      const token = getAdmin();
      if (token) {
        const response = await HttpService.get(
          `${Constants.apiURL + Constants.refBundleURL}/fetchForms`,
          { headers: { Authorization: `Bearer ${token}` } },
          null
        );
        console.log(response);
        if (response.data) {
          setStoredMenuItems(response.data);
          setLoumacMenuItems(response.data);
          setLoumacMenus(response.data);
        } else {
        }
      }
    } catch (error) {}
  };
  const getMenuItemName = (keyword: string) => {
    return keyword.toLocaleLowerCase().replaceAll('_', ' ');
  };

  return (
    <aside id="sidebar" className="sidebar">
      <List
        sx={{
          width: '100%',
          color: '#000',
          fontFamily: 'Poppins',
          maxWidth: 360,
          bgcolor: 'background.paper',
        }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            Menu
          </ListSubheader>
        }
      >
        {loumacMenus.map((menuItem: any) => {
          return (
            <Box key={menuItem.section}>
              <ListItemButton
                onClick={() => {
                  handleClick(menuItem.section);
                }}
              >
                <ListItemIcon>
                  {menuItem.section === 'DATA_MANAGEMENT' ? (
                    <DashboardOutlinedIcon />
                  ) : (
                    <DnsOutlinedIcon />
                  )}
                </ListItemIcon>
                <ListItemText
                  sx={{
                    '& .MuiTypography-root': {
                      textTransform: 'capitalize !important',
                      display: 'inline-block',
                    },
                  }}
                  primary={getMenuItemName(menuItem.section)}
                />
                {open === true &&
                currentMenu === getActiveItemModule(menuItem.section) ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )}
              </ListItemButton>
              {menuItem.forms.sort().map((formItem: any) => {
                return (
                  <Collapse
                    key={formItem}
                    in={
                      open &&
                      currentMenu === getActiveItemModule(menuItem.section)
                    }
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {
                        <ListItemButton
                          onClick={() => {
                            navigate(getLink(menuItem.section, formItem));
                          }}
                          sx={{ pl: 9 }}
                        >
                          <ListItemIcon
                            className={
                              getActiveMenu(menuItem.section, formItem)
                                ? 'activeLink'
                                : 'normal'
                            }
                            sx={{ minWidth: '10px' }}
                          >
                            <CircleIcon
                              sx={
                                isActive(formItem)
                                  ? styles.activeLink
                                  : styles.link
                              }
                            />
                          </ListItemIcon>
                          <ListItemText
                            sx={{
                              '& .MuiTypography-root': {
                                textTransform: 'capitalize !important',
                                display: 'inline-block',
                                color: isActive(formItem)
                                  ? '#000B29'
                                  : '#848EA9',
                                fontSize: '12px',
                                transform: 'translateY(-2px)',
                              },
                            }}
                            primary={getMenuItemName(formItem)}
                          />
                        </ListItemButton>
                      }
                    </List>
                  </Collapse>
                );
              })}
            </Box>
          );
        })}
      </List>
    </aside>
  );
};
const styles = {
  nav: {
    display: 'flex',
    gap: '20px',
    padding: '10px',
  },
  link: {
    textDecoration: 'none',
    display: 'flex',
    width: '4px',
    // color: 'black',
  },
  activeLink: {
    textDecoration: 'none',
    color: '#00f4ff',
    fontWeight: 'bold',
    width: '4px',
  },
  dropdown: {
    paddingLeft: '20px',
    display: 'block',
  },
};
export default SideBar;
